var map = {
	"./anamaria/bobo_de_camarao.js": 92,
	"./anamaria/cachorro_quente.js": 93,
	"./anamaria/moqueca_de_camarao.js": 94,
	"./anamaria/peixe_ao_forno.js": 95,
	"./anamaria/picanha_ao_forno.js": 96,
	"./anamaria/salada_de_camarao.js": 97,
	"./anamaria/torta_de_atum.js": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;